<template>
  <div class="no-data">
    <!-- <img alt src="../../assets/img/coupon-center/no-data.png" /> -->
    暂无数据
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.no-data {
  padding-top: 2rem;
  text-align: center;
  font-size: @fz32;
  color: @base;
  img {
    width: 4rem;
    height: 2.8rem;
  }
}
</style>
